import { Component, View, ViewModel } from "binder";
import  { CheckboxView } from "./checkbox-view"
import { getAsBoolean } from "../utilities";

export class CheckboxViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.indeterminate = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new CheckboxView();
    }
    public getTypeId(): string {
        return "VM-83DAA835-7B60-44C5-B11B-B0F8FE94A85E"
    }

    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set checked(v: boolean) { this._checked = v; } public get checked(): boolean { return this._checked;} private _checked: boolean;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;
    public set indeterminate(v: boolean) { this._indeterminate = getAsBoolean(v); } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
            
}
